module.exports = __webpack_public_path__ + "img/icon_line.2e6c4a1e.svg";